import { FieldOptionBase } from 'module/api/field/types';
import { byLabel } from 'module/helpers/comparators/by-label';
import { optionsTransformer } from 'module/helpers/filter/option-transformer';
import { MultiSelectField } from 'module/types/filter-field/field/filterable-field';
import { NoValue } from 'module/ui/components/atoms/no-value/empty-cell';
import { SelectFieldOption } from 'module/ui/components/molecules/field-editable-value/option';
import { StyledSelect } from 'module/ui/components/molecules/field-editors/components/components';
import { Space } from 'antd';
import { forwardRef } from 'react';
import { EditableProps } from './editable-props';

interface Props extends Partial<EditableProps<number[]>> {
  field: MultiSelectField;
}

export const MultiSelectFieldValue = forwardRef<HTMLDivElement, Props>(
  ({ field, editable, onChange }, ref) => {
    const {
      options: { activeOptions, allOptions },
    } = optionsTransformer(field);

    return !editable ? (
      (field?.value ?? []).length === 0 ? (
        <NoValue />
      ) : (
        <Space size={2}>
          {allOptions
            .filter((x) => field.value!.includes(x.value))
            .sort(byLabel)
            .map((option) => (
              <SelectFieldOption key={option.value} option={option} />
            ))}
        </Space>
      )
    ) : (
      <StyledSelect
        ref={ref}
        type="tag"
        isMulti
        isClearable
        menuIsOpen
        options={activeOptions}
        value={allOptions.filter((x) => (field.value ?? []).includes(x.value))}
        onChange={(latest: FieldOptionBase[]) =>
          onChange?.((latest ?? []).sort(byLabel).map((x) => x.value))
        }
      />
    );
  },
);

MultiSelectFieldValue.displayName = 'MultiSelectFieldValue';
